import { plural } from "../ui/text";

// The calm headline and progress for the top of My tasks. Never shows a negative or a division by zero.
export function summarize(tasks) {
  const total = tasks.length;
  const done = tasks.filter((t) => t.completed).length;
  const left = Math.max(0, total - done);
  let headline = "";
  let sub = "";
  if (total > 0 && done === 0) {
    headline = "Ready when you are.";
    sub = left === 1 ? "One small step to start with." : `${left} small steps to start with.`;
  } else if (total > 0 && left === 0) {
    headline = "All done. Nice work.";
    sub = "Take a break.";
  } else if (total > 0) {
    headline = `${plural(done, "small step", "small steps")} done.`;
    sub = `${left} to go, no rush.`;
  }
  const percent = total === 0 ? 0 : Math.round((done / total) * 100);
  return { total, done, left, headline, sub, percent };
}

// What gets pre-filled in the chat when a student taps "Break this down with Rigby".
export function breakDownMessage(text) {
  return `Help me break this down into small steps: ${String(text || "").trim()}`.trim();
}

export const MAX_TASK_LENGTH = 500;
